import products from '../assets/data/products';
import defaultFallback from '../assets/images/double-sofa-01.png';

/**
 * Maps any item (from Redux, localStorage, Firestore, or props)
 * to its valid image asset or custom uploaded image.
 */
export const getProductImg = (item) => {
  if (!item) return defaultFallback;

  // 1. If passed a direct string URL (or Base64 data:image URL)
  if (typeof item === 'string' && item.trim().length > 0) {
    return item.trim();
  }

  // 2. If item has its own explicit imgUrl (custom upload, Base64, or web URL)
  if (item.imgUrl && typeof item.imgUrl === 'string' && item.imgUrl.trim().length > 0) {
    const trimmed = item.imgUrl.trim();
    // Ignore old stale localhost port hashes if not a base64
    if (!trimmed.startsWith('data:') && trimmed.includes('localhost:') && !trimmed.startsWith('http')) {
      // try to resolve
    } else {
      return trimmed;
    }
  }

  // 3. Fallback to catalog bundled asset by ID if imgUrl is missing
  if (item.id !== undefined && item.id !== null) {
    const catalogProduct = products.find((p) => String(p.id) === String(item.id));
    if (catalogProduct && catalogProduct.imgUrl) {
      return catalogProduct.imgUrl;
    }
  }

  // 4. Fallback to catalog by name
  if (item.productName) {
    const catalogProduct = products.find(
      (p) => p.productName.trim().toLowerCase() === item.productName.trim().toLowerCase()
    );
    if (catalogProduct && catalogProduct.imgUrl) {
      return catalogProduct.imgUrl;
    }
  }

  return defaultFallback;
};

/**
 * OnError handler for <img> tags.
 * Falls back gracefully to catalog product image or atelier default asset.
 */
export const handleImgError = (e, item) => {
  if (!e || !e.currentTarget) return;

  const target = e.currentTarget;

  if (item && item.id) {
    const catalogProduct = products.find((p) => String(p.id) === String(item.id));
    if (catalogProduct && catalogProduct.imgUrl && target.src !== catalogProduct.imgUrl) {
      target.src = catalogProduct.imgUrl;
      return;
    }
  }

  if (target.src !== defaultFallback) {
    target.src = defaultFallback;
  }
};
